export default {
  general: {
    showFavourites: true,
    showSoldNeighbourhoods: false,
    showSoldSlides: false,
    showSoldPrice: false,
    appResetTimeoutMinutes: 15,
  },
  filter: {
    enabled: false,
  },
};
